module.exports = __webpack_public_path__ + "static/media/logo-white.171849f5.png";